import { render, staticRenderFns } from "./userPackages.vue?vue&type=template&id=460fbfca&scoped=true&"
import script from "./userPackages.vue?vue&type=script&lang=js&"
export * from "./userPackages.vue?vue&type=script&lang=js&"
import style0 from "./userPackages.vue?vue&type=style&index=0&id=460fbfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460fbfca",
  null
  
)

export default component.exports